<template>
  <section class="privacy-center">
    <header class="privacy-center__header">
        <h1
          class="privacy-center__header__title"
        >
          {{ $t('privacyCenter.title') }}
        </h1>
      </header>

      <div
        class="privacy-center__body"
      >
        <p>
          {{ $t('privacyCenter.content.description') }}
        </p>
        <p>
          {{ $t('privacyCenter.content.explanation') }}
        </p>
        <AppAccordion>
          <AppAccordionItem v-for="(section, index) in $t('privacyCenter.content.sections')" :key="`section-${index}`">
            <template v-slot:title>{{ section.title }}</template>
            <template v-slot:content >
              <div v-html="prepareContent(section)"></div>
            </template>
          </AppAccordionItem>
        </AppAccordion>
      </div>
  </section>
</template>

<script>
const pageAddressMap = {
  SUPPORT_PAGE_ADDRESS: 'https://help.playkids.com',
  PARTNERS_PAGE_ADDRESS: 'https://policies.playkidsapp.com/pt/partners-list/may-2020'
}
export default {
  name: 'PrivacyCenter',
  methods: {
    prepareContent (section) {
      if (section.links) {
        let content = section.content
        section.links.forEach(it => {
          const [key, value] = Object.entries(it)[0]
          content = content.replace(`${key}`, `<a href="${pageAddressMap[key]}">${value}</a>`)
        })
        return content
      }
      return section.content
    }
  }
}
</script>

<style lang="scss" scoped>
.privacy-center {
  &__header {
    padding: 40px 0 20px;
    text-align: center;

    &__title {
      font: {
        weight: 900;
        size: 3.1rem;
      }
      line-height: 110%;
      text-transform: uppercase;
    }
  }

  &__body {
    padding-bottom: 60px;
    text-align: justify;
    h1 {
      margin: 1.5em 0;
      font-weight: 900;
      line-height: 120%;
      text-transform: uppercase;
      font-size: 2.1rem;
    }
    p {
      margin: 1.5em 0;
      font-size: 1rem;
      line-height: 140%;
    }
  }

  // Responsiveness
  @include media(map-get($breakpoint, 'medium')) {
    &__header {
      &__title {
        font-size: 1.9rem;
      }
    }

    &__body {
      padding-bottom: 40px;
      h1 {
        margin: 1em 0;
        line-height: 110%;
        font-size: 1.8rem;
      }
      p {
        margin: 1.3em 0;
        font-size: 0.9rem;
      }
    }
  }
}
</style>
